import React from 'react';
import type * as CSS from 'csstype';
import { useParticipant } from 'core';
import { ParticipantPresenterProps } from 'features/ParticipantItem/types';
import { RaiseHandIcon } from 'features/RaiseHand';
import { useRaiseHand } from 'features/RaiseHand/hooks/useRaiseHand';
import { useSIPParticipant } from 'useCase/SIPTelephony/useSIPParticipant';
import { ParticipantBar } from '../../components/ParticipantBar';
import { useParticipantItem, OrientationEnum } from '../../hooks/useParticipantItem';
import { GridVideoRenderer, PlaceholderWrapper, SIPCallIcon, SIPPlaceholder } from './view';

export const GridSIP: React.FC<ParticipantPresenterProps> = ({
    isAudioMuted,
    isVideoEnabled,
    participant,
    onSizeChanged,
}) => {
    const { cameraPublication, isLocal } = useParticipant(participant);
    const { getObjectFit } = useParticipantItem();
    const objectFit: CSS.Properties['objectFit'] = getObjectFit(
        OrientationEnum.Landscape,
        cameraPublication?.dimensions,
    );
    const track = cameraPublication?.track;
    const isShowVideo = isVideoEnabled && track;

    const { checkIsHandRaised } = useRaiseHand();
    const handRaised = checkIsHandRaised(participant);

    const { getSIPParticipantName } = useSIPParticipant();
    const name = getSIPParticipantName(participant);

    return (
        <>
            {isShowVideo && track ? (
                <GridVideoRenderer
                    track={track}
                    isLocal={isLocal}
                    $objectFit={objectFit}
                    participantId={participant.identity}
                    onSizeChanged={onSizeChanged}
                />
            ) : (
                <PlaceholderWrapper>
                    <SIPPlaceholder participantId={participant.sid}>
                        <SIPCallIcon icon="icCall" />
                    </SIPPlaceholder>
                </PlaceholderWrapper>
            )}

            <ParticipantBar isAudioMuted={isAudioMuted} name={name} />
            {handRaised && <RaiseHandIcon />}
        </>
    );
};
